import type { CSSProperties, HTMLAttributes, ReactNode } from 'react';
import { cx } from '../utils/cx.js';
import styles from './SimpleGrid.module.css';

export type SimpleGridCols = { base?: number; sm?: number; md?: number; lg?: number };

export type SimpleGridProps = HTMLAttributes<HTMLDivElement> & {
  cols?: number | SimpleGridCols;
  spacing?: 'xs' | 'sm' | 'md' | 'lg';
  children: ReactNode;
};

const spaceMap = {
  xs: 'var(--wp-space-8)',
  sm: 'var(--wp-space-12)',
  md: 'var(--wp-space-16)',
  lg: 'var(--wp-space-24)',
};

export function SimpleGrid({ cols = 1, spacing = 'md', className, style, children, ...rest }: SimpleGridProps) {
  const gap = spaceMap[spacing];
  if (typeof cols === 'number') {
    return (
      <div
        className={cx(styles.grid, className)}
        style={{
          gap,
          gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))`,
          ...style,
        }}
        {...rest}
      >
        {children}
      </div>
    );
  }
  return (
    <div
      className={cx(styles.grid, styles.responsive, className)}
      style={
        {
          gap,
          '--wp-cols-base': cols.base ?? 1,
          '--wp-cols-sm': cols.sm ?? cols.base ?? 1,
          '--wp-cols-md': cols.md ?? cols.sm ?? cols.base ?? 1,
          '--wp-cols-lg': cols.lg ?? cols.md ?? cols.sm ?? cols.base ?? 1,
          ...style,
        } as CSSProperties
      }
      {...rest}
    >
      {children}
    </div>
  );
}
